import Vue from 'vue'
import Vuex from 'vuex'

import createLogger from 'vuex/dist/logger'
import {localStoragePlugin} from './plugins'

import ajax from './modules/ajax'
import company from './modules/company'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    ajax,
    company
  },
  strict: debug,
  plugins: debug ? [createLogger(), localStoragePlugin] : [localStoragePlugin]
})



// WEBPACK FOOTER //
// ./src/app/config/store/index.js